import { useState } from 'react';
import { PortalBrandHeader } from './PortalBrandHeader.jsx';

function isDesktopNav() {
  return typeof window !== 'undefined' && window.matchMedia('(min-width: 961px)').matches;
}

export function AppShell({
  branding,
  brandFallback,
  subtitle,
  wordmarkSrc,
  nav,
  topbar,
  footer,
  children,
  mainTourId,
  rootRef,
  searchPlaceholder = 'Search…',
  onSearch,
}) {
  const [sidebarOpen, setSidebarOpen] = useState(isDesktopNav);
  const [query, setQuery] = useState('');
  const headerBranding = branding || brandFallback || { name: 'Portal' };

  return (
    <div
      ref={rootRef}
      className={`dashboard app-shell${sidebarOpen ? ' is-sidebar-open' : ' is-sidebar-collapsed'}${branding ? ' portal-branded' : ''}`}
    >
      <button
        type="button"
        className="sidebar-backdrop"
        aria-label="Close menu"
        onClick={() => setSidebarOpen(false)}
      />
      <aside className="sidebar">
        <PortalBrandHeader branding={headerBranding} subtitle={subtitle} wordmarkSrc={wordmarkSrc} />
        <nav
          className="sidebar-nav"
          aria-label="Main"
          onClick={(e) => {
            if (e.target.closest('a') && !isDesktopNav()) {
              setSidebarOpen(false);
            }
          }}
        >
          {nav}
        </nav>
        {footer ? <div className="sidebar-footer">{footer}</div> : null}
      </aside>
      <div className="app-shell-body">
        <header className="topbar">
          <button
            type="button"
            className="icon-btn topbar-menu-btn"
            aria-label={sidebarOpen ? 'Collapse menu' : 'Open menu'}
            aria-expanded={sidebarOpen}
            onClick={() => setSidebarOpen((open) => !open)}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M5 7h14M5 12h14M5 17h14" strokeLinecap="round" />
            </svg>
          </button>
          <form
            className="topbar-search"
            role="search"
            onSubmit={(e) => {
              e.preventDefault();
              const term = query.trim();
              if (term) {
                onSearch?.(term);
              }
            }}
          >
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
              <circle cx="11" cy="11" r="6.5" />
              <path d="M16 16.5L20 20.5" strokeLinecap="round" />
            </svg>
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={searchPlaceholder}
              aria-label={searchPlaceholder}
            />
          </form>
          {topbar}
        </header>
        <main className="dashboard-main" data-tour={mainTourId}>
          {children}
        </main>
      </div>
    </div>
  );
}
